<template>
    <div class="user-access-filter-form mb-3" style="min-width: 487px; max-width: 600px">
        <div class="accordion data-filter">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button bold"
                            :class="{collapsed: !isOpen}"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target=".collapseFirst"
                            aria-expanded="true"
                            aria-controls="collapseFirst"
                    >
                        User Access Filter
                    </button>
                </h2>
                <div class="accordion-collapse collapse collapseFirst"
                     :class="{ show: isOpen }"
                     data-bs-parent=".data-filter">
                    <div class="accordion-body">

                        <form class="form-floating">

                            <div class="row mb-4">
                                <div class="col">

                                    <div class="form-floating">
                                        <input v-model="email" type="text" class="form-control"
                                               placeholder="part of email address for search"/>
                                        <label>Email address</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col">
                                    <div class="form-floating">
                                        <select v-model="status" class="form-select">
                                            <option value="">All</option>
                                            <option value="1">Yes</option>
                                            <option value="0">No</option>
                                        </select>
                                        <label>Activity</label>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="form-floating">
                                        <select v-model="nodes_pools_group_id" class="form-select">
                                            <option value="">All</option>
                                            <option value="2">free</option>
                                            <option value="1">premium</option>
                                        </select>
                                        <label>Access type</label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col">
                                    <label><span class="text-black-50">Update date</span> <b>from</b></label>
                                    <date-picker v-model="updated_at_from" type="date"
                                                 format="YYYY/MM/DD"></date-picker>
                                </div>
                                <div class="col">
                                    <label><span class="text-black-50">Update date</span> <b>to</b></label>
                                    <date-picker v-model="updated_at_to" type="date" format="YYYY/MM/DD"></date-picker>
                                </div>
                            </div>


                            <div class="row text-center">
                                <div class="col align-items-center">
                                    <button type="button" class="btn btn-primary me-2" @click="onSearch">Search</button>
                                    <button type="button" class="btn btn-outline-danger me-2" @click="onClean">Clear
                                    </button>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    name: "UserAccessFilterForm",
    components: {DatePicker},
    data() {
        return {
            isOpen: false,
            email: '',
            status: '',
            nodes_pools_group_id: '',
            updated_at_from: '',
            updated_at_to: '',
        }
    },
    methods: {
        onSearch() {
            this.$emit('onFilter', {
                email: this.email,
                status: this.status,
                nodes_pools_group_id: this.nodes_pools_group_id,
                updated_at_from: this.updated_at_from,
                updated_at_to: this.updated_at_to,
            })
        },
        onClean() {
            this.email = this.status = this.nodes_pools_group_id = this.updated_at_from = this.updated_at_to = ''
            this.onSearch()
        }
    }
}
</script>